export enum WraparoundCornerRoofStyle {
  Gable = 'gable',
  Hiproof = 'hiproof',
}
